/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import { Button } from '@alifd/next';
import { Modal, Spin, DatePicker, Select } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
import Swal from 'sweetalert2';
import axios from 'axios';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import Tab from '@/components/UI/mobile/Tab';
import locale from 'antd/lib/date-picker/locale/zh_TW';

const PostalFrontDesk = () => {
  const residentPointsRecord = client.service('residentPointsRecord');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const communityData = client.service('communityData');
  const [residentPointsRecordArr, setResidentPointsRecordArr] = useState([]);
  const [payDate, setPayDate] = useState([]);
  const [pointTotal, setPointTotal] = useState(0);
  const [previewAddPoint, setPreviewAddPoint] = useState(false);
  const [pointValue, setPointValue] = useState(0);
  const [point, setPoint] = useState(0);
  const [householdNumber, setHouseholdNumber] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const pointArr = [100, 200, 300, 400, 500, 600];
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState(moment().startOf('M').valueOf());
  const [choose, setChoose] = useState('month');
  const [residentPointsRecordObject, setResidentPointsRecordObject] = useState(
    {}
  );
  const [buyPoint, setBuyPoint] = useState(false);
  // const [payDate]

  useEffect(() => {
    client
      .reAuthenticate()
      .then((res) => {
        setHouseholdNumber(res.user.householdNumbers[0]);
        residentAccountNumbers
          .find({
            query: {
              householdNumber: { $in: res.user.householdNumbers },
            },
          })
          .then((residentNumber) => {
            console.log(
              residentNumber.data[0].finalPoints +
                residentNumber.data[0].buyPoint
            );
            setPointTotal(
              residentNumber.data[0].finalPoints +
                residentNumber.data[0].buyPoint,
              'pointTotal'
            );
          })
          .catch((err) => {
            console.log('==find household fail:', err);
          });

        residentPointsRecord
          .find({
            query: {
              householdNumber: { $in: res.user.householdNumbers },
            },
          })
          .then((res) => {
            setResidentPointsRecordObject(res.data);
          });

        residentPointsRecord
          .find({
            query: {
              householdNumber: { $in: res.user.householdNumbers },
              createdTime: {
                $gte: month,
                $lte: moment(month).endOf(choose).valueOf(),
              },
            },
          })
          .then((res) => {
            setTotalPage(res.data.length);
          });
        setLoading(true);
        residentPointsRecord
          .find({
            query: {
              householdNumber: { $in: res.user.householdNumbers },
              createdTime: {
                $gte: month,
                $lte: moment(month).endOf(choose).valueOf(),
              },
              $limit: 10 * page,
              $sort: { createdTime: -1 },
            },
          })
          .then((residents) => {
            setLoading(false);
            setResidentPointsRecordArr(residents.data);
            // setHistory(residents.data);
            setPayDate(residents.data.filter((item) => item.type === '儲值'));
          })
          .catch((err) => {
            console.log('==find household fail:', err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
    communityData
      .find({})
      .then((res) => {
        setPointValue(res.data[0].pointValue);
        console.log(res.data[0]);
        setBuyPoint(res.data[0].isBuyPoint);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [
    communityData,
    residentAccountNumbers,
    residentPointsRecord,
    isUpdate,
    page,
    month,
  ]);

  const disabledDate = (current) => {
    return (
      residentPointsRecordObject.filter(
        (item) =>
          moment(item.createdTime).format('YYYY/MM/DD') ===
          moment(current).format('YYYY/MM/DD')
      ).length === 0
    );
  };
  console.log(buyPoint);
  return (
    <>
      <div className={styles.mobilePostal}>
        <div className={styles.mobilePostalBackground} />

        <div className={styles.visitorHeader}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={`icon/ic_point_blue.svg`}
              alt="ic_point_blue"
              style={{ width: '4vw', color: '#FFFFFF' }}
            />
            點數 <span className={styles.pointTotal}>{pointTotal}</span>
          </div>
          {buyPoint && (
            <div>
              <Button
                type="primary"
                className={styles.pointBtn}
                onClick={() => {
                  setPreviewAddPoint(true);
                }}
              >
                儲值點數
              </Button>
            </div>
          )}
        </div>
        <div className={styles.pointContent}>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Select
              className={styles.selectButton}
              value={choose}
              size="large"
              onChange={(value) => {
                setChoose(value);
                setMonth(moment().startOf(value).valueOf());
              }}
            >
              <Select.Option value="date">日</Select.Option>
              <Select.Option value="month">月</Select.Option>
            </Select>
            <DatePicker
              inputReadOnly
              allowClear={false}
              style={{ marginBottom: 10, marginLeft: 10 }}
              size="large"
              picker={choose}
              locale={locale}
              value={moment(month)}
              onChange={(value) => setMonth(value.startOf(choose).valueOf())}
              disabledDate={disabledDate}
            />
          </div>
          <Tab options={['點數使用記錄', '點數儲值管理']} onChange={setTab} />
          {tab === 0 && (
            <div
              className={styles.pointArea}
              onScroll={(event) => {
                const current = event.currentTarget;
                if (
                  current.scrollHeight -
                    (current.scrollTop + current.clientHeight) <
                  5
                ) {
                  setPage((pre) => pre + 1);
                }
                if (event.currentTarget.scrollTop === 0) {
                  setPage(1);
                }
              }}
            >
              {residentPointsRecordArr.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={styles.postalContainer}
                    style={{ marginTop: 10 }}
                  >
                    <div className={styles.postalFlag}>
                      <div
                        className={
                          item.type === '支出'
                            ? styles.status
                            : styles.statusBlue
                        }
                      >
                        {item.type}
                      </div>
                      <div className={styles.time}>
                        {moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss')}
                      </div>
                    </div>
                    <div className={styles.postalContentTop}>
                      <div className={styles.postalOrder}>
                        <div className={styles.orderBox}>
                          <div className={styles.orderText}>點數</div>
                          <div className={styles.order}>{item.point}</div>
                        </div>
                        <div className={styles.postalFlag2}>
                          <div className={styles.time2}>
                            {moment(item.createdTime).format(
                              'YYYY-MM-DD HH:mm:ss'
                            )}
                          </div>
                          <div
                            className={
                              item.type === '支出'
                                ? styles.status2
                                : styles.status2Blue
                            }
                          >
                            {item.type}
                          </div>
                        </div>
                      </div>

                      <div className={styles.postalPlacement}>
                        <div className={styles.placementText}>說明</div>
                        <div className={styles.placement}>{item.remarks}</div>
                      </div>
                    </div>

                    <hr className={styles.divider} />
                  </div>
                );
              })}
              {residentPointsRecordArr.length === 0 && (
                <div style={{ marginTop: 10 }}>尚無點數記錄</div>
              )}
              {loading && residentPointsRecordArr.length !== totalPage ? (
                <div style={{ textAlign: 'center', marginTop: 10 }}>
                  <Spin
                    indicator={
                      <LoadingOutlined style={{ fontSize: 24 }} spin />
                    }
                  />
                </div>
              ) : (
                <div
                  style={{ textAlign: 'center', marginTop: 10, height: 20 }}
                />
              )}
            </div>
          )}

          {tab === 1 && (
            <div className={styles.pointArea}>
              {payDate.map((item, index) => {
                return (
                  <div key={index} className={styles.postalContainer}>
                    <div className={styles.postalFlag}>
                      <div
                        className={
                          item.isPay ? styles.statusBlue : styles.status
                        }
                      >
                        {item.isPay ? '已繳費' : '未繳費'}
                      </div>
                      <div className={styles.time}>
                        {moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss')}
                      </div>
                    </div>
                    <div className={styles.postalContentTop}>
                      <div className={styles.postalOrder}>
                        <div className={styles.orderBox}>
                          <div className={styles.orderText}>點數</div>
                          <div className={styles.order}>{item.point}</div>
                        </div>
                        <div className={styles.postalFlag2}>
                          <div className={styles.time2}>
                            {moment(item.createdTime).format(
                              'YYYY-MM-DD HH:mm:ss'
                            )}
                          </div>
                          <div
                            className={
                              item.isPay ? styles.status2Blue : styles.status2
                            }
                          >
                            {item.isPay ? '已繳費' : '未繳費'}
                          </div>
                        </div>
                      </div>

                      <div className={styles.postalOrder}>
                        <div className={styles.orderBox}>
                          <div className={styles.orderText}>儲值人</div>
                          <div className={styles.placement}>
                            {item.userName}
                          </div>
                        </div>
                      </div>
                      <div className={styles.postalOrder}>
                        <div className={styles.orderBox}>
                          <div className={styles.orderText}>說明</div>
                          <div className={styles.placement}>{item.remarks}</div>
                        </div>
                      </div>
                    </div>

                    <hr className={styles.divider} />
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {/* 點數儲值 */}
        <Modal
          okText="儲值"
          closable={false}
          cancelText="取消"
          mask={false}
          className={styles.modal2}
          // width={"100vw"}
          visible={previewAddPoint}
          onOk={() => {
            Swal.fire({
              title: `確定要儲值${point}點?`,
              text: '按下確定後將會於併入下個月帳單!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                axios('/ezcon/api/communityPoint', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    householdNumber,
                    point,
                    money: point * pointValue,
                  },
                })
                  .then(() => {
                    setPreviewAddPoint(false);
                    setPoint(0);

                    setIsUpdate((pre) => !pre);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            });
          }}
          onCancel={() => {
            setPreviewAddPoint(false);
          }}
        >
          <div>
            <div className={styles.pointColumn}>
              <div>快速儲值</div>
              <div>1點＝{pointValue}元</div>
            </div>

            <div className={styles.previewContainer}>
              {pointArr.map((item, index) => (
                <Button
                  key={index}
                  className={
                    point === item ? styles.AddPointCheck : styles.AddPoint
                  }
                  onClick={() => setPoint(parseInt(item, 10))}
                >
                  {item}點
                </Button>
              ))}
            </div>
            <div className={styles.pointStatus}>
              <div>儲值:</div>
              <div className={styles.pointNum}>
                <span className={styles.pointValue}>{point}</span>點
              </div>
            </div>
            <div className={styles.pointStatus}>
              <div>合計:</div>
              <div className={styles.pointNum}>
                <span className={styles.pointValue}>{point * pointValue}</span>
                元
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default PostalFrontDesk;
